module.exports = __webpack_public_path__ + "img/16581268_L.a28e6073.png";